import { render } from "./ProjectPerformersInfo.vue?vue&type=template&id=2f7dc21c&scoped=true"
import script from "./ProjectPerformersInfo.vue?vue&type=script&lang=js"
export * from "./ProjectPerformersInfo.vue?vue&type=script&lang=js"

import "./ProjectPerformersInfo.vue?vue&type=style&index=0&id=2f7dc21c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f7dc21c"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QTr,QBtn});
